import BlackButton from "../custom-components/BlackButton";
import "../../styles/common-components/ModuleHeader.css";

function ModuleHeader({ heading, buttons }) {
  return (
    <div className="module-header">
      <span className="module-header-title">{heading}</span>
      <div className="module-header-buttons">
        {buttons &&
          buttons.map(
            (btn, index) =>
              btn.show && (
                <BlackButton key={index} onClickhandle={btn.onClick}>
                  {btn.label}
                </BlackButton>
              )
          )}
      </div>
    </div>
  );
}

export default ModuleHeader;